export const headerData = {
  tableName: 'Users',
  hasSearch: true,
  hasDelete: true,
  hasEdit: true,
  hasPaging: true,
  hasDefault: true,
  isEditDeleteDefault: true, //add it when u need to hide edit and delete if isDefault true
  deleteSubtext:
    'This will permanently remove it and all associated values from the system. This action cannot be undone.',
  fields: [
    {
      fieldName: 'variableName',
      headerName: 'Name',
      hasSort: true,
    },
    {
      fieldName: 'description',
      headerName: 'Description',
      hasSort: true,
    },
    {
      fieldName: 'variableTypeText',
      headerName: 'Type',
      hasSort: true,
    },
    {
      fieldName: 'dateUpdated',
      headerName: 'Update',
      hasSort: true,
      isDatetime: true,
      isDesc: true,
    },
  ],
};
